module.exports = __webpack_public_path__ + "img/ClickForSound_7.bc563eb7.png";